// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UJCh","type":"styles_type__2rV7P","choices":"styles_choices__3qaZ5"};